<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">
          Corte de Tienda por Fecha
        </h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-6">
              <TiendaSelectComponent :current="current" />
            </div>
            <div class="col-6">
              <label>Fecha</label>
              <input v-model="current.fecha" class="form-control" type="date" />
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-success col-6" ref="cerrarModal" type="button" @click="GenerarReporte(current)">
              Corte de Tienda
            </button>
            <button class="btn btn-success col-6" ref="cerrarModal" type="button" @click="GenerarReporteDetalleVenta()">
              Detalle de Venta
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import CorteCajaService from "@/services/cxc/CorteCajaService";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    PaginationComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      current: {
        tienda: "",
        fecha: "",
      },
      lista_precio: "",
      currentPage: 1,
      searchtext: "",
      filter_activo: "",
      data: [],
    };
  },
  mounted() {
    let params = new URLSearchParams(location.search);
    var tienda = params.get("tienda");
    this.current.tienda = tienda;
  },
  methods: {
    GenerarReporte() {
      let self = this;
      if (!self.ValidarForm()) {
        return
      }
      self.ImprimirReporteTienda();
    },
    ImprimirReporteTienda() {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/CorteDeTiendaGlobal.jrxml&Tienda=${self.current.tienda}&Fecha=${self.current.fecha}`
      );
    },
    ValidarForm() {
      let self = this;
      if (!self.current.tienda) {
        Notifications.alert.error(
          "Corte Global",
          "El campo de tienda no puede ser nulo"
        );
        return false;
      }
      if (!self.current.fecha) {
        Notifications.alert.error(
          "Corte Global",
          "El campo de fecha no puede ser nulo"
        );
        return false;
      }
      return true;
    },
    GenerarReporteDetalleVenta() {
      let self = this;
      if (!self.ValidarForm()) {
        return
      }
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/DetalleVenta_FormaPago_Tienda.jrxml&Id=0&Tienda=${self.current.tienda}&Fecha=${self.current.fecha}`
      );
    },
    onRefreshData() { },
  },
};
</script>